/*
 *  Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import dayjs from "dayjs";
import { MIN_FILTER_DATE as minSelectableDate } from "../constants";

export function useDateRange(valueFrom?: string, valueTo?: string) {
  const updatedFrom = dayjs(valueFrom);
  const updatedTo = dayjs(valueTo);
  const selectableDate = dayjs(minSelectableDate);

  const isDateToBeforeDateFrom =
    valueFrom != null && valueTo != null && updatedTo.isBefore(updatedFrom);
  const isDateFromBeforeMinSelectable = updatedFrom.isBefore(selectableDate);
  const isDateToBeforeMinSelectable = updatedTo.isBefore(selectableDate);

  const isDateInvalid =
    isDateToBeforeDateFrom ||
    isDateFromBeforeMinSelectable ||
    isDateToBeforeMinSelectable;

  return {
    isDateToBeforeDateFrom,
    isDateFromBeforeMinSelectable,
    isDateToBeforeMinSelectable,
    isDateInvalid,
  };
}
